(() => {
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  const initializeDogLpHeader = (
    header
  ) => {
    if (
      !header ||
      header.dataset
        .dogLpHeaderInitialized ===
        'true'
    ) {
      return;
    }

    const drawer =
      header.querySelector(
        '[data-dog-lp-menu]'
      );

    const panel =
      header.querySelector(
        '[data-dog-lp-menu-panel]'
      );

    const openButton =
      header.querySelector(
        '[data-dog-lp-menu-open]'
      );

    const closeButton =
      header.querySelector(
        '[data-dog-lp-menu-close]'
      );

    header.dataset
      .dogLpHeaderInitialized =
      'true';

    let lastFocusedElement = null;
    let closeTimer = null;
    let lastScrollY =
      window.scrollY;
    let scrollFrame = null;

    const scrollThreshold = 8;
    const topThreshold = 24;

    const setHeaderDirection = () => {
      scrollFrame = null;

      if (
        document.body.classList.contains(
          'dog-lp-menu-open'
        )
      ) {
        return;
      }

      const currentScrollY =
        Math.max(
          window.scrollY,
          0
        );

      if (
        currentScrollY <=
        topThreshold
      ) {
        header.classList.remove(
          'is-scrolling-down',
          'is-scrolling-up'
        );

        lastScrollY =
          currentScrollY;

        return;
      }

      const scrollDifference =
        currentScrollY -
        lastScrollY;

      if (
        Math.abs(
          scrollDifference
        ) < scrollThreshold
      ) {
        return;
      }

      if (
        scrollDifference > 0
      ) {
        header.classList.add(
          'is-scrolling-down'
        );

        header.classList.remove(
          'is-scrolling-up'
        );
      } else {
        header.classList.add(
          'is-scrolling-up'
        );

        header.classList.remove(
          'is-scrolling-down'
        );
      }

      lastScrollY =
        currentScrollY;
    };

    const requestHeaderUpdate =
      () => {
        if (scrollFrame) {
          return;
        }

        scrollFrame =
          window.requestAnimationFrame(
            setHeaderDirection
          );
      };

    window.addEventListener(
      'scroll',
      requestHeaderUpdate,
      {
        passive: true
      }
    );

    if (
      !drawer ||
      !panel ||
      !openButton ||
      !closeButton
    ) {
      return;
    }

    const getFocusableElements =
      () => {
        return Array.from(
          panel.querySelectorAll(
            focusableSelector
          )
        ).filter(
          (element) =>
            !element.hasAttribute(
              'hidden'
            )
        );
      };

    const closeDrawer = () => {
      if (closeTimer) {
        window.clearTimeout(
          closeTimer
        );
      }

      drawer.classList.remove(
        'is-open'
      );

      drawer.setAttribute(
        'aria-hidden',
        'true'
      );

      openButton.setAttribute(
        'aria-expanded',
        'false'
      );

      document.body.classList.remove(
        'dog-lp-menu-open'
      );

      closeTimer =
        window.setTimeout(
          () => {
            closeTimer = null;

            if (
              !drawer.classList.contains(
                'is-open'
              )
            ) {
              drawer.hidden = true;
            }
          },
          220
        );

      lastScrollY =
        window.scrollY;

      if (
        lastFocusedElement
          ?.isConnected
      ) {
        lastFocusedElement.focus();
      }
    };

    const openDrawer = () => {
      if (closeTimer) {
        window.clearTimeout(
          closeTimer
        );

        closeTimer = null;
      }

      lastFocusedElement =
        document.activeElement;

      header.classList.remove(
        'is-scrolling-down'
      );

      header.classList.add(
        'is-scrolling-up'
      );

      drawer.hidden = false;

      drawer.setAttribute(
        'aria-hidden',
        'false'
      );

      openButton.setAttribute(
        'aria-expanded',
        'true'
      );

      document.body.classList.add(
        'dog-lp-menu-open'
      );

      window.requestAnimationFrame(
        () => {
          drawer.classList.add(
            'is-open'
          );

          closeButton.focus();
        }
      );
    };

    openButton.addEventListener(
      'click',
      openDrawer
    );

    closeButton.addEventListener(
      'click',
      closeDrawer
    );

    drawer.addEventListener(
      'click',
      (event) => {
        if (
          event.target === drawer
        ) {
          closeDrawer();
        }
      }
    );

    drawer.addEventListener(
      'keydown',
      (event) => {
        if (
          event.key === 'Escape'
        ) {
          closeDrawer();

          return;
        }

        if (
          event.key !== 'Tab'
        ) {
          return;
        }

        const focusableElements =
          getFocusableElements();

        if (
          !focusableElements.length
        ) {
          event.preventDefault();

          return;
        }

        const firstElement =
          focusableElements[0];

        const lastElement =
          focusableElements[
            focusableElements.length -
              1
          ];

        if (
          event.shiftKey &&
          document.activeElement ===
            firstElement
        ) {
          event.preventDefault();

          lastElement.focus();

          return;
        }

        if (
          !event.shiftKey &&
          document.activeElement ===
            lastElement
        ) {
          event.preventDefault();

          firstElement.focus();
        }
      }
    );
  };

  const initializeDogLpHeaders = (
    scope = document
  ) => {
    scope
      .querySelectorAll(
        '[data-dog-lp-header]'
      )
      .forEach(
        initializeDogLpHeader
      );

    if (
      scope.matches?.(
        '[data-dog-lp-header]'
      )
    ) {
      initializeDogLpHeader(
        scope
      );
    }
  };

  initializeDogLpHeaders();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeDogLpHeaders(
        event.target
      );
    }
  );
})();